import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { createRoot } from "react-dom/client";
import App from "./App";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// index.js or App.js
{
    /* The following line can be included in your src/index.js or App.js file */
  }

createRoot(document.getElementById("root")).render(<App/>)

